<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="车间调拨单"
      :page="page"
      :show-query="true"
      :get-data-func="api.list"
      v-if="trendShow"
      urlHash="business/stock/outsourcingallocation"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      api: require("@/api/stock/stOutAllotDoc").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      trendShow: true,
    };
  },
};
</script>
